var exports = {
  "d": "affirmative__E8s2fT",
  "K": "copilotRun__YoR3_f",
};

module.exports = exports;
